import { render, staticRenderFns } from "./MobilePlans.vue?vue&type=template&id=41a0b682&"
import script from "./MobilePlans.vue?vue&type=script&lang=js&"
export * from "./MobilePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports